import Script from "next/script";
import { CLEVERTAP_ID, REGION } from "@/config/endpoints";

export default function CleverTap() {

  return (
    <Script
      id="clevertap-init"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `
          var clevertap = {
            event: [],
            profile: [],
            account: [],
            onUserLogin: [],
            notifications: [],
            privacy: []
          };
          clevertap.spa = true; 
          clevertap.account.push({ id: "${CLEVERTAP_ID}" }, "${REGION}");
          clevertap.privacy.push({ optOut: false }); 
          clevertap.privacy.push({ useIP: false });  

          (function() {
            var wzrk = document.createElement('script');
            wzrk.type = 'text/javascript';
            wzrk.async = true;
            wzrk.src = 'https://d2r1yp2w7bby2u.cloudfront.net/js/clevertap.min.js';
            var s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(wzrk, s);
          })();
        `,
      }}
    />
  );
}
